import { render, staticRenderFns } from "./ProcedurePage.vue?vue&type=template&id=78a9e0ed&scoped=true&"
import script from "./ProcedurePage.vue?vue&type=script&lang=js&"
export * from "./ProcedurePage.vue?vue&type=script&lang=js&"
import style0 from "./ProcedurePage.vue?vue&type=style&index=0&id=78a9e0ed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a9e0ed",
  null
  
)

export default component.exports